import { render, staticRenderFns } from "./editActivityTypeDetails.vue?vue&type=template&id=245bbaf0&scoped=true&"
import script from "./editActivityTypeDetails.vue?vue&type=script&lang=js&"
export * from "./editActivityTypeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245bbaf0",
  null
  
)

export default component.exports